import axios from 'axios';

export const getCurrentUser = () => axios.get('/api/user');

export const putCurrentUser = (data) => axios.put('/api/user', data);
